import type { ReactNode } from 'react'
import { OverallComment } from './overall-comment'
import type { ReviewBodyProps } from './review-tab'

/**
 * Ticked-card review body (LG-905 D4) — the per-type `task` entry in
 * `review-tab.tsx`'s `BODY_BY_TYPE` map.
 *
 * A ticked card is the one kind of work with nothing to read: the client
 * asserted they did it, and that assertion is already in the row's header
 * (title, and when it was marked done). So this body is only what makes the
 * card reviewable at all — somewhere for the coach to write.
 *
 * It is not `DefaultReviewBody` for one reason: that body renders the shared
 * `PacingSection`, and a ticked card's `durationSeconds` is 0 by construction.
 * "0:00" next to a chapter reading is not a missing number, it is a wrong one.
 * The ranking banner is absent for the same reason — nothing ranks a tick.
 */
export function TaskReview(props: ReviewBodyProps): ReactNode {
  const { submission, getSectionRef } = props

  return (
    <div className="flex flex-col gap-3.5">
      <div ref={getSectionRef('overall')}>
        <OverallComment submissionId={submission.id} />
      </div>
    </div>
  )
}
